import { ProductTag } from '../constants/products';

import { isSavage } from './brandNameHelper';
import { convertStringsToInts } from './convertStringsToInts';

export function isForcedSoldOut(product, isVip, isFemale) {
  const tagIdSet = new Set(convertStringsToInts(product.tagIdList));
  if (isSavage()) {
    if (tagIdSet.has(ProductTag.fakeSoldOut)) {
      return true;
    }

    if (isVip && tagIdSet.has(ProductTag.soldOutVip)) {
      return true;
    } else if (tagIdSet.has(ProductTag.soldOutLead)) {
      return true;
    }

    return false;
  }

  return (
    (tagIdSet.has(ProductTag.fakeSoldOut) && isVip) ||
    (tagIdSet.has(ProductTag.fakeSoldOutMens) && isFemale && isVip)
  );
}
